import React from 'react';
import './MobileContactBar.css';

const MobileContactBar = ({ toggleContactMenu }) => {
  return (
    <div className='mobile-contact-bar-wrapper'>
      <div className='mobile-contact-bar'>
        <div className='contact-menu-toggle'>
          <button onClick={toggleContactMenu} aria-label="Toggle contact menu">
            <i className="fa-solid fa-bars"></i>
          </button>
        </div>
        <div className='contact-menu-toggle'>
          <a href="tel:352-812-0831"><i className="fa-solid fa-phone"></i><span className="sr-only">Call us</span></a>
        </div>
      </div>
    </div>
  );
};

export default MobileContactBar;
